import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-prompt-modal',
  templateUrl: './prompt-modal.component.html',
  styleUrls: ['./prompt-modal.component.scss']
})
export class PromptModalComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<PromptModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: { title: string, message: string, btnText: string }) {
  }

  ngOnInit(): void {

  }

}
